import { render } from "./Item.vue?vue&type=template&id=5fd9bb1a&scoped=true"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"

import "./Item.vue?vue&type=style&index=0&id=5fd9bb1a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd9bb1a"]])

export default __exports__